import React from "react"
import { isIthClient } from "@/utils"
import sigmaLogoSvg from "@/assets/Sigma-logo.svg"
import { ithOpenAIAgent } from "@/utils/client"

export default function Sigma() {
    const handleClick = () => {
        ithOpenAIAgent();
    }
    if (!isIthClient()) {
        return null
    }
   return (
    <div className="fixed right-6 bottom-6">
        <img src={sigmaLogoSvg} alt="sigma-logo" className="w-10 h-10 hover:shadow-md rounded-full cursor-pointer" onClick={handleClick} />
    </div>
  )
}
